import React, {useState} from 'react';
import {Form, Formik} from 'formik';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from '../../common/hook';
import {optionsLanguage} from './options/options';
import {message, Select} from 'antd';
import './style.css';
import {useInputWithFocus} from "../../common/hook/useInputWithFocus";
import {setLanguageLevelAC} from "../../app/popups-reducer";
import {ReactComponent as SelectArrayIcon} from '../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../assets/i/arrow-up-icon.svg';
import {useParams} from "react-router-dom";
import {fetchStudentInfo} from "../../features/model/service/student-info/fetchStudentInfo";
import {
    fetchLevelUpdate,
    UpdateLevelParamsWithGroupId
} from "../../features/model/service/fetch-level-update/fetchLevelUpdate";

interface MyFormValues {
    id: string;
    groupName: string;
    noteText: string;
    beginLanguageLevel: string;
    currentLanguageLevel: string;
}

export const FormLanguageLevel = () => {
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState<boolean>(false);
    const [openTwo, setOpenTwo] = useState<boolean>(false);
    const {groupId, studentId} = useParams();

    const beginLanguageLevel = useAppSelector(state => state.studentInfo.data?.beginLanguageLevel);
    const currentLanguageLevel = useAppSelector(state => state.studentInfo.data?.currentLanguageLevel);

    const [selectedElementaryLevel, setSelectedElementaryLevel] = useState<string>(beginLanguageLevel || '');

    const [selectedCurrentLevel, setSelectedCurrentLevel] = useState<string>(currentLanguageLevel || '');


    // const filterSelect = selectedElementaryLevel ?


    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false, false]);

    const success = () => {
        message.success('Уровень языка успешно изменен');
    };

    const onClickHandler = () => {
        dispatch(setLanguageLevelAC(false));
    };

    const handleChange = (name: string, value: string) => {
        if (name === 'elementary') {
            setSelectedElementaryLevel(value);
        } else if (name === 'current') {
            setSelectedCurrentLevel(value);
        }

    };

    const selectedElementaryLevelId = optionsLanguage.find(option => option.value === selectedElementaryLevel)?.id;


    const filteredOptions = optionsLanguage.filter(option => {
        // Преобразуем значение option.value в число и сравниваем с id выбранного selectedElementaryLevel
        return parseInt(option.id.toString()) >= parseInt(selectedElementaryLevelId?.toString() || '0');
    });




    const handleSubmit = (values: MyFormValues) => {
        const languageLevels = {
            beginLanguageLevel: selectedElementaryLevel,
            currentLanguageLevel: selectedCurrentLevel,
        };

        const updateParams: UpdateLevelParamsWithGroupId = {
            studentId: studentId,
            newLevel: languageLevels,
            groupId: groupId,
        };

        dispatch(fetchLevelUpdate(updateParams))
            .then(() => {
                dispatch(fetchStudentInfo({groupId, studentId}));
                onClickHandler();
                success();
            })
            .catch((error) => {
                console.error("Error while updating level:", error);
            });
    };

    return (
        <Formik
            initialValues={{
                id: '',
                groupName: '',
                noteText: '',
                beginLanguageLevel: beginLanguageLevel || '',
                currentLanguageLevel: currentLanguageLevel || '',
            }}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            {({handleSubmit}) => (
                <>
                    <p className="h3 popup-title">Уровень языка</p>
                    <Form action="#" className="form" onSubmit={handleSubmit}>
                        <div className="fields-row gap">
                            <div className="course-type" onClick={() => setOpen(!open)}>
                                <span className={beginLanguageLevel || selectedElementaryLevel ? 'active-label' : ''}>Начальный уровень</span>
                                <Select
                                    style={{width: '100%'}}
                                    options={optionsLanguage}
                                    onFocus={() => handleFocus(0)}
                                    onBlur={handleBlur}
                                    onChange={(value) => {
                                        handleChange('elementary', value);
                                        setSelectedElementaryLevel(value);
                                    }}
                                    suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                                    defaultValue={selectedElementaryLevel || ''}
                                />
                            </div>
                            <div className="course-type" onClick={() => setOpenTwo(!openTwo)}>
                                <span className={currentLanguageLevel || selectedCurrentLevel ? 'active-label' : ''}>Текущий уровень</span>
                                <Select
                                    style={{width: '100%'}}
                                    options={filteredOptions}
                                    onFocus={() => handleFocus(1)}
                                    onBlur={handleBlur}
                                    onChange={(value) => {
                                        handleChange('current', value);
                                        setSelectedCurrentLevel(value);
                                    }}
                                    suffixIcon={openTwo ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                                    defaultValue={selectedCurrentLevel || ''}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn full-width">
                            <span>Сохранить</span>
                        </button>
                    </Form>
                    <span className="js-close-popup" onClick={onClickHandler}>
                         <CloseIcon/>
                    </span>
                </>
            )}
        </Formik>
    );
};

